import { render, staticRenderFns } from "./_label.vue?vue&type=template&id=2e9df553"
import script from "./_label.vue?vue&type=script&lang=js"
export * from "./_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports